const IntercomLauncherIcon = () => (
  <svg
    width="32"
    height="55"
    viewBox="0 0 32 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_3431)">
      <path
        d="M5 55C2.23858 55 -9.78513e-08 52.7614 -2.18557e-07 50L-2.18557e-06 5C-2.30628e-06 2.23857 2.23857 -9.78513e-08 5 -2.18557e-07L32 -1.39876e-06L32 55L5 55Z"
        fill="#2196F3"
      />
      <path
        d="M9.82495 27.5L19.825 37.5L22.175 35.15L14.5416 27.5L22.1749 19.85L19.825 17.5L9.82495 27.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_3431">
        <path
          d="M5 55C2.23858 55 -9.78513e-08 52.7614 -2.18557e-07 50L-2.18557e-06 5C-2.30628e-06 2.23857 2.23857 -9.78513e-08 5 -2.18557e-07L32 -1.39876e-06L32 55L5 55Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IntercomLauncherIcon;
